<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand bg-celcomblue navbar-dark"
    :class="{'bg-celcomblue navbar-dark': type === 'default'}"
  >

    <!-- Navbar links -->
    <ul class="navbar-nav align-items-center ml-md-auto">
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div class="pr-3 sidenav-toggler"
             :class="{active: $sidebar.showSidebar, 'sidenav-toggler-dark': type === 'default', 'sidenav-toggler-light': type === 'light'}"
             @click="toggleSidebar">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>




      <li class="nav-item d-sm-none">
        <a class="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li>
      <li class="nav-item">
        <small class="text-secondary">
          <i class="fas fa-clock"></i> {{timeServe}}
        </small>
        <small class="text-secondary">
          <i class="fas fa-calendar-alt"></i> {{ momentDate() }}
        </small>
      </li>
      <base-dropdown style="display:none" class="nav-item"
                     tag="li"
                     title-classes="nav-link"
                     title-tag="a"
                     icon="ni ni-bell-55"
                     menu-classes="dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden">
        <template>
        </template>
      </base-dropdown>
    </ul>
    <ul class="navbar-nav align-items-center ml-auto ml-md-0">



      <li class="nav-item" v-if="getUserSub!=null">
        <div class="media-body ml-3 d-none d-lg-block text-secondary">
          <div class="p-2">
            <i class="fas fa-user mr-2"></i>
            <el-tooltip content="Cerrar Sesion" placement="bottom" style="cursor: pointer;">
              <badge rounded type="celcomblue" >
                {{getUserSub.shortName}}
                <i class="fas fa-times" @click="cerrar_sub_user"></i>
              </badge>
            </el-tooltip>
          </div>

        </div>
      </li>



      <li class="nav-item">
        <div class="media-body ml-3 d-none d-lg-block text-secondary">
          <div class="p-2">
            <i class="fas fa-envelope-open-text mr-2"></i>
            <el-tooltip content="Créditos Disponibles" placement="bottom">
              <badge rounded type="celcomblue">
                {{ numberWithCommas( (getUserSub!=null) ? getUserSub.remainingSms :  dataUserActual.remainingSms) }}
              </badge>
            </el-tooltip>
          </div>

        </div>
      </li>

      <base-dropdown menu-on-right
                     class="nav-item mr-3"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0">
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <div class="media align-items-center">
                  <span class="avatar avatar-sm rounded-circle">
                    <img alt="Image placeholder" src="/img/theme/usuario_default.png">
                  </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">
                {{ dataUserActual.shortName }}
              </span>
            </div>
          </div>
        </a>

        <template>

          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">¡Bienvenido!</h6>
          </div>
          <a href="/cuenta/perfil" class="dropdown-item">
            <i class="ni ni-single-02"></i>
            <span>Mi perfil</span>
          </a>
          <div class="dropdown-divider"></div>
          <a @click="logout" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </a>

        </template>
      </base-dropdown>

    </ul>

  </base-nav>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';
import {  Select, Option } from 'element-ui'
import { getUser, setUser,getUserSub, encryptAES, horaAhora, obtenerInfoCuenta,getUserRealTime,getTimeServe,
getUserAdmin } from '@/util/util.js';
import swal from 'sweetalert2';


import moment from 'moment';

import AES256 from 'aes-everywhere';
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Config from '@/config/config.js'

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
      dataUser: {},
      dataUserActual: getUser(),
      timeServe:moment().format('HH:mm:ss A'),
      customer_admin:getUserAdmin(),
      simple_customer_admin:"",
      adminSi: getUser(),
      getUserSub : getUserSub()

    };
  },
 watch: {

      'simple_customer_admin'(newVal){

      },

    },
  methods: {



    cerrar_sub_user(){
      if(this.getUserSub!=null){

        swal({
          title: 'Sesion de '+this.getUserSub.shortName+" cerrada",
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success',
          type: 'success',
        }).then(function() {
        window.location.href="/cuenta/usuarios"
        })

        localStorage.removeItem('user_sub');
        this.getUserSub="";

      }


    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    momentDate() {
      moment.locale('es')
      return moment().format('L');
    },
    logout(){

        localStorage.removeItem('user');
        localStorage.removeItem('user_sub');
        localStorage.removeItem('user_admin');
        localStorage.removeItem('user_permisos');
        window.location.href="/login";

    },
    getTime(){
      var self = this;
      setTimeout(async function () {  self.timeServe = await getTimeServe(); self.getTime(); } , 1000)
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  },
  async mounted(){


    await getUserRealTime();

    this.dataUserActual =  getUser();

  },
  created(){

      this.getTime();

  }
};
</script>
<style lang="scss">
.nav-item {
  small {
    display: block;
  }
}
.sidenav-toggler-line {
  background-color: #FFFFFF;
}
</style>
